import {
  Files,
  FileText,
  Mail,
  MessageSquare,
  RefreshCcw,
  ScrollText,
  ShieldUser,
  Users,
} from 'lucide-react';

// Define available entities and their actions
export const ROLE_ENTITIES = {
  communication: { actions: ['read', 'send-email'], icon: MessageSquare },
  control: { actions: ['read', 'sync'], icon: RefreshCcw },
  kyc: {
    actions: [
      'read',
      'edit',
      'send-email',
      'documents',
      'approval-1',
      'approval-2',
      'approval-risk-1-2',
      'approval-kyc',
      'change-risk-level',
    ],
    icon: FileText,
  },
  'kyc-pdf-texts': {
    actions: ['read', 'edit'],
    icon: FileText,
  },
  users: { actions: ['read', 'create', 'edit', 'delete'], icon: Users },
  roles: { actions: ['read', 'create', 'edit', 'delete'], icon: ShieldUser },
  'email-templates': {
    actions: ['read', 'create', 'edit', 'delete'],
    icon: Mail,
  },
  'document-groups': {
    actions: ['read', 'create', 'edit', 'delete'],
    icon: Files,
  },
  logs: { actions: ['read', 'xmls'], icon: ScrollText },
} as const;

export type RoleEntity = keyof typeof ROLE_ENTITIES;
export type RoleAction = (typeof ROLE_ENTITIES)[RoleEntity]['actions'][number];
export type EntityPermissions = Record<string, string[]>;
// Export all entities for easy access
export const ALL_ENTITIES: RoleEntity[] = Object.keys(
  ROLE_ENTITIES
) as RoleEntity[];

// Export all actions for easy access
export const ALL_ACTIONS: RoleAction[] = Array.from(
  new Set(Object.values(ROLE_ENTITIES).flatMap(entity => entity.actions))
) as RoleAction[];
